(function () {
  const button = document.getElementById('back-to-top');
  if (!button) return;

  const scrollOffset = parseInt(button.dataset.scrollOffset, 10) || 400;

  function updateVisibility() {
    button.classList.toggle('is-visible', window.scrollY > scrollOffset);
  }

  window.addEventListener('scroll', updateVisibility, { passive: true });
  updateVisibility();

  button.addEventListener('click', function () {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });
})();
